angular.module('vastdesk').
  component('htmlVideoPlayer',  {
    bindings: {
      playerId: '@',
      src: '@',
      poster: '@'
    },
    template: '<video id="{{$htmlVideoPlayerCtrl.playerId}}" ng-src="{{$htmlVideoPlayerCtrl.src}}" ng-attr-poster="{{$htmlVideoPlayerCtrl.poster}}" width="100%" controls></video>',
    controllerAs: '$htmlVideoPlayerCtrl',
    controller: ['$rootScope', '$element', function($rootScope, $element) {

      var self = this;

      $rootScope.$on('videoChange', function(e, args) {
        if (args.playerId === self.playerId) {
          self.src = args.src;
          self.poster = args.poster;
        }
      });

    }]
});
